import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["circle"]

  mouseenter() {
    this.circleTarget.style.strokeDashoffset = "0"
  }

  mouseleave() {
    this.circleTarget.style.strokeDashoffset = "138"
  }

  connect() {
    this.element.addEventListener("mouseenter", this.mouseenter.bind(this))
    this.element.addEventListener("mouseleave", this.mouseleave.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.mouseenter)
    this.element.removeEventListener("mouseleave", this.mouseleave)
  }
}
